import { Html } from '@mv/ui-kit/primitives';

export function VideoMedia({ alt, uri }: { alt?: string | null; uri: string }) {
	return <Html.Video aria-label={alt ?? undefined} className="max-w-full" controls src={uri} />;
}
